import {useCallback, useEffect, useState} from "react";

const PREVIEW_ENDPOINT = '/api/v2/livestream/previews/';

function getPreviews() {
  return fetch(PREVIEW_ENDPOINT).then(resp => resp.json());
}

export default function useChannelPreviews(defaultPreviews) {
  let [previews, setPreviews] = useState(defaultPreviews);
  let request = useCallback(() => getPreviews().then(result => setPreviews(result)), []);

  useEffect(() => {
    let timer = setInterval(request, 300 * 1000);
    return () => clearInterval(timer);
  }, []);

  return previews;
}